(function () {
  function initSection(section) {
    if (!section || section.dataset.misakiXmasReady === 'true') return;

    section.dataset.misakiXmasReady = 'true';

    section.querySelectorAll('[data-xmas-slider]').forEach(function (slider) {
      var name = slider.getAttribute('data-xmas-slider');
      var previous = section.querySelector('[data-xmas-slider-prev="' + name + '"]');
      var next = section.querySelector('[data-xmas-slider-next="' + name + '"]');

      function move(direction) {
        slider.scrollBy({
          left: direction * Math.max(slider.clientWidth * 0.82, 280),
          behavior: 'smooth'
        });
      }

      function updateControls() {
        var maxScrollLeft = Math.max(slider.scrollWidth - slider.clientWidth, 0);

        if (previous) previous.disabled = slider.scrollLeft <= 2;
        if (next) next.disabled = slider.scrollLeft >= maxScrollLeft - 2;
      }

      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      slider.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-misaki-xmas-b2b]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
